<script setup lang="ts">
import { computed, ref } from 'vue'
import { NForm, NFormItem, useMessage } from 'naive-ui'
import { useWorkspaceFolderStore } from '@/store/modules/folder'
import { useAppStore, useUserStore } from '@/store'
import { useBasicLayout } from '@/hooks/useBasicLayout'
import { t } from '@/locales'

const props = defineProps({
  dataSource: {
    type: Object,
    required: true,
    default: {},
  },
  title: {
    type: String,
    default: '',
  },
  show: {
    type: Boolean,
    default: false,
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
  isView: {
    type: Boolean,
    default: false,
  },
  isCreate: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['onClose'])

const appStore = useAppStore()
const { isMobile } = useBasicLayout()
const userStore = useUserStore()

const showModal = ref(props.show)
const message = useMessage()
const modelRef = ref({
  ...props.dataSource,
})

const workspaceFolderStore = useWorkspaceFolderStore()
const workSpaceId = computed(() => userStore.workSpaceId)

// Hàm tạo folder mới
async function handleCreateFolder(folderName: string) {
  const newFolder = await workspaceFolderStore.createFolder(folderName, workSpaceId.value)
  if (newFolder) {
    // Xử lý thành công (ví dụ: đóng modal, hiển thị thông báo)
  }
}

async function handleUpdateFolder(folderId: number, folderName: string) {
  const success = await workspaceFolderStore.updateFolderName(folderId, folderName, workSpaceId.value)
  if (success) {
    // Xử lý thành công
  }
}

const rulesRef = ref()

const closeModal = (reload: boolean) => {
  showModal.value = false
  emit('onClose', reload)
}

const handleSave = async () => {
  try {
    const res = props.isEdit
      ? await handleUpdateFolder(modelRef.value.id, modelRef.value.name)
      : await handleCreateFolder(modelRef.value.name)

    message.success(props.isEdit ? 'Sửa thành công' : 'Thêm mới thành công')
    if (!props.isEdit && isMobile.value)
      appStore.setSiderCollapsed(true)
    closeModal(true)
  }
  catch (err) {
    console.error('handleSave error:', err)
  }
}

const handleCancel = () => {
  closeModal(false)
}
</script>

<template>
  <AppModal
    v-model:show="showModal"
    preset="card"
    transform-origin="center"
    :title="title"
    style="width: 500px"
    class="!rounded-2xl"
    content-class="!px-4 !py-0"
    header-class="!p-4"
    footer-class="!p-4 !w-full !pt-3"
    :mask-closable="false"
    @after-leave="handleCancel"
    @esc="handleCancel"
  >
    <NForm
      ref="formRef"
      :label-width="80"
      :model="modelRef"
      :rules="rulesRef"
    >
      <NFormItem :label="t('folder.folderName')" path="title">
        <AppInput v-model:value="modelRef.name" :disabled="isView" :placeholder="t('folder.folderName')" />
      </NFormItem>
    </NForm>
    <template #footer>
      <div class="flex justify-end gap-[16px]">
        <AppButton ghost type="primary" class="min-w-[120px]" @click="handleCancel">
          {{ $t('common.cancel') }}
        </AppButton>
        <AppButton v-if="!props.isView" type="primary" class="min-w-[120px]" :disabled="!modelRef.name" @click="handleSave">
          {{ props.isCreate ? t('common.add') : t('common.save') }}
        </AppButton>
      </div>
    </template>
  </AppModal>
</template>

<style scoped>
</style>
